import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applySeo, buildHomeSeo, getSiteUrl, setNoindex } from '@/lib/seo';
import {
  injectArticleJsonLd,
  injectHomeFaqJsonLd,
  injectSiteJsonLd,
  removeJsonLd,
} from '@/lib/jsonld';
import { getArticleBySlug } from '@/mocks/articles';

const LANGS = ['en', 'fr', 'da', 'de'];

export default function SeoManager() {
  const location = useLocation();

  useEffect(() => {
    injectSiteJsonLd();
  }, []);

  useEffect(() => {
    const site = getSiteUrl();
    const segments = location.pathname.split('/').filter(Boolean);
    const lang = segments[0] || '';
    const isArticle =
      segments.length === 3 && segments[1] === 'article' && LANGS.includes(lang);
    const slug = isArticle ? segments[2] : undefined;

    if (isArticle && slug) {
      const article = getArticleBySlug(slug);
      if (article) {
        const url = `${site}/${lang}/article/${slug}`;
        const keywords = `AllChinaBuy Spreadsheet, ${article.category}, AllChinaBuy guide, AllChinaBuy`;
        applySeo({
          title: article.metaTitle,
          description: article.metaDescription,
          keywords,
          canonical: url,
          ogTitle: article.metaTitle,
          ogDescription: article.metaDescription,
          ogType: 'article',
          ogUrl: url,
          ogImage: article.heroImg,
          twitterCard: 'summary_large_image',
          twitterTitle: article.metaTitle,
          twitterDescription: article.metaDescription,
          twitterImage: article.heroImg,
        });
        setNoindex(false);
        injectArticleJsonLd(article, url, lang);
        return;
      }
    }

    const isHome = segments.length === 0 || (segments.length === 1 && LANGS.includes(lang));

    if (isHome) {
      applySeo(buildHomeSeo());
      setNoindex(false);
      injectHomeFaqJsonLd();
      return;
    }

    // Non-indexable / not found
    applySeo({
      title: 'Page Not Found',
      description: 'The page you are looking for could not be found.',
      keywords: 'AllChinaBuy Spreadsheet',
      canonical: `${site}${location.pathname}`,
      ogTitle: 'Page Not Found',
      ogDescription: 'The page you are looking for could not be found.',
      ogType: 'website',
      ogUrl: `${site}${location.pathname}`,
      ogImage: null,
      twitterCard: 'summary',
      twitterTitle: 'Page Not Found',
      twitterDescription: 'The page you are looking for could not be found.',
      twitterImage: null,
    });
    setNoindex(true);
    removeJsonLd('route-jsonld');
  }, [location.pathname]);

  return null;
}